import { ToggleButton } from './toggle-button';
import { MediaQuery } from '../../util';

const menuOpenClass = 'menu-toggle__container--open';

export class MenuToggleButton extends ToggleButton {

    constructor(button) {
        super(button);
        if (!window.matchMedia(`only screen and ${MediaQuery.largeUpViewport}`).matches) {
            this.open = false;
        }
    }

    _onOpen() {
        super._onOpen();
        this._button.parentNode.classList.add(menuOpenClass);
    }

    _onClose() {
        super._onClose();
        this._button.parentNode.classList.remove(menuOpenClass);
    }
}